import React from 'react';
import { ExclamationTriangleIcon } from '@heroicons/react/24/outline';

const DeleteUserModal = ({ handleClose, Values }) => {
    const { user, onConfirm } = Values;

    const handleConfirm = () => {
        onConfirm();
        handleClose();
    };

    return (
        <div className="p-6">
            <div className="flex items-center justify-center mb-4">
                <div className="w-12 h-12 bg-red-100 dark:bg-red-900 rounded-full flex items-center justify-center">
                    <ExclamationTriangleIcon className="h-6 w-6 text-red-600 dark:text-red-400" />
                </div>
            </div>
            
            <h2 className="text-xl font-bold text-gray-900 dark:text-white text-center mb-2">
                Confirm Removal
            </h2>
            
            <p className="text-gray-600 dark:text-gray-300 text-center mb-6">
                Are you sure you want to remove <span className="font-semibold text-gray-900 dark:text-white">{user?.name || 'this user'}</span> from this venue?
            </p>
            
            <p className="text-sm text-gray-500 dark:text-gray-400 text-center mb-6">
                This action will soft delete them from the venue. This action cannot be undone.
            </p>
            
            <div className="flex gap-3">
                <button
                    onClick={handleClose}
                    className="flex-1 px-4 py-2 bg-gray-200 hover:bg-gray-300 dark:bg-gray-700 dark:hover:bg-gray-600 text-gray-900 dark:text-white rounded-lg transition-colors"
                >
                    Cancel
                </button>
                <button
                    onClick={handleConfirm}
                    className="flex-1 px-4 py-2 bg-red-600 hover:bg-red-700 text-white rounded-lg transition-colors"
                >
                    Remove User
                </button>
            </div>
        </div>
    );
};

export default DeleteUserModal;
